import React from "react";

import { Fonts } from "../../design/Font";
 
import { Colors } from "../../design/Colors";

/**
 * Dropdown (component)
 * 
 * displays a list of items that can be selected from when toggled.
 * selecting an item changes the value of the dropdown, and triggers
 * an onChange function
 */
export default class Dropdown extends React.Component{
    constructor(props){
        super(props)
        this.state={
            
        }
    }
    /**
     * handleDownload
     * 
     * @param {URL} fileUrl 
     * 
     * downloads the file pointed to by fileUrl passed in Parameters.
     * works by creating and appending an <a> element and clicking it,
     * then removing the element.
     */
    handleDownload = (form) => {
        const link = document.createElement('a');
        link.href = form.download;
        link.download = form.filename;
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render(){
        const forms = this.props.forms
        return(
            <div >
                <div style={{...styles.table_header}}>
                    <div style={{...styles.table_header_item, width:'10vw'}}><span style={{...Fonts.white_text}}>Document Title</span></div>
                    <div style={{...styles.table_header_item, width:'13vw'}}><span style={{...Fonts.white_text}}>Description</span></div>
                    <div style={{...styles.table_header_item, width:'9vw'}}><span style={{...Fonts.white_text}}>File</span></div>
                    <div style={{...styles.table_header_item, width:'7vw'}}><span style={{...Fonts.white_text}}>Last Update</span></div>
                    <div style={{...styles.table_header_item, width:'6vw'}}><span style={{...Fonts.white_text}}>Action</span></div>
                </div>
                {forms.map(form=>(
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                        <div style={{...styles.table_entry}}>
                            <div style={{...styles.table_entry_item, width:'10vw'}}><span style={{...Fonts.text, paddingLeft:'0.4vw'}}>{form.title}</span></div>
                            <div style={{...styles.table_entry_item, width:'13vw'}}><span style={{...Fonts.text, paddingLeft:'0.4vw'}}>{form.description}</span></div>
                            <div style={{...styles.table_entry_item, width:'9vw'}}><span style={{...Fonts.text, paddingLeft:'0.4vw'}}>{form.filename}</span></div>
                            <div style={{...styles.table_entry_item, width:'7vw'}}><span style={{...Fonts.text, paddingLeft:'0.4vw'}}>{form.updated}</span></div>
                            <div style={{...styles.table_entry_item, width:'6vw'}}>
                                <div onClick={()=>{this.handleDownload(form)}} style={{display:'flex',justifyContent:'center',alignItems:'center',padding:'0.4vh', marginLeft:'0.4vw',border:'1px solid #F80', borderRadius:5,cursor:'pointer'}}><span style={{...Fonts.text,marginLeft:'1vh', marginRight:'1vh',color:'#F80'}}>Download</span></div>
                            </div>
                        </div>
                        <div style={{backgroundColor:Colors.grey,height:2, width:'45.1vw'}}/>
                    </div>
                ))}
            </div>
        )
    }

}

const styles={
    table_header:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center'
    },
    table_header_item:{
        display:'flex',
        backgroundColor:Colors.blue,
        margin:1,
        height:'4vh',
        alignItems:'center'
    },
    table_entry:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center'
    },
    table_entry_item:{
        display:'flex',
        backgroundColor:Colors.white,
        margin:1,
        height:'5vh',
        alignItems:'center',
    },
}